import React from 'react';

export const MODAL_PARTS = {
  HEADER: Symbol('Modal.Header'),
  BODY: Symbol('Modal.Body'),
} as const;

type ComponentWithType<P> = React.ComponentType<P> & {
  $$type?: symbol;
};

export function getModalPartChildComponent<T>(
  childrenArray: ReturnType<typeof React.Children.toArray>,
  part: symbol,
): React.ReactElement<T> | undefined {
  return childrenArray.find((child): child is React.ReactElement<T> => {
    return React.isValidElement(child) && (child.type as ComponentWithType<T>).$$type === part;
  });
}
